import React, { type JSX } from 'react';
import { QRCodeSVG } from 'qrcode.react';

import './styles/index.scss';

export const BASE_URL = 'https://mgtrl.co/';

export interface Props {
  baseURL?: string;
  code: string;
}

const QRCodeWrapper: React.FC<Props> = ({
  baseURL = BASE_URL,
  code,
}: Props): JSX.Element => (
  <div className="QRCodeWrapper">
    <QRCodeSVG value={`${baseURL}${code}`} size={120} />
    <div className="QRCodeWrapper_code">{`${code.substring(
      0,
      Math.round(code.length / 2)
    )} ${code.substring(Math.round(code.length / 2))}`}</div>
  </div>
);

export default QRCodeWrapper;
